import React, { Component } from "react";
import { toast } from 'react-toastify';

// Uppy integration
import Uppy from "@uppy/core";
import Dashboard from "@uppy/dashboard";
import GoogleDrive from "@uppy/google-drive";
import Dropbox from "@uppy/dropbox";
// import OneDrive from "@uppy/onedrive";
import Url from "@uppy/url";
import Transloadit from "@uppy/transloadit";
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import { addEventNameToEndpoint } from '../../utils/common';
import '@uppy/core/dist/style.css';
import '@uppy/url/dist/style.css';
import '@uppy/dashboard/dist/style.css';

import _ from "lodash";
import "./UploadModalContent.scss";

const NOTIFY_URL = `${process.env.REACT_APP_TRANSLOADIT_NOTIFY_URL_UPLOAD}/items/v1/thumbnail-notification`;
const CC_COMPANION_URL = process.env.REACT_APP_COMPANION_URL; // instead of Transloadit.COMPANION;

/**
 * ChangeThumbnailModalContent
 * Change the thumbnail of an item
 * Note: this doesn't have to use the common initialization, because it's very specific to just uploading
 * and image fore the thumbnail only
 */
class ChangeThumbnailModalContent extends Component {
  componentDidMount() {
    this.onOpenUppyModal();
  }

  onOpenUppyModal = async () => {
    const tokens = await this.props.Auth.currentSession();

    const uppy = new Uppy({
      id: 'uppyChangeThumbnailModal',
      debug: false,
      autoProceed: false,
      restrictions: {
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ['image/*']
      },
      locale: {
        strings: {
          dropPasteImport: 'Drop images here, paste, %{browse} images or import from',
        }
      }
    })
      .use(Dashboard, {
        trigger: '.UppyModalOpenerBtn',
        inline: true,
        target: '.uppy-thumbnail-container',
        replaceTargetContent: true,
        showProgressDetails: true,
        height: 470,
        browserBackButtonClose: true,
        proudlyDisplayPoweredByUppy: false,
        waitForMetadata: true // https://uppy.io/docs/transloadit/#waitForMetadata
      })
      .use(GoogleDrive, { target: Dashboard, companionUrl: CC_COMPANION_URL })
      .use(Dropbox, { target: Dashboard, companionUrl: CC_COMPANION_URL })
      // .use(OneDrive, { target: Dashboard, companionUrl: CC_COMPANION_URL })
      .use(Url, { target: Dashboard, companionUrl: CC_COMPANION_URL })
      .use(Transloadit, {
        waitForMetadata: false,
        getAssemblyOptions: (file) => {
          let templateId = process.env.REACT_APP_TEMPLATE_THUMBNAIL_UPLOAD; // {stage} doc upload

          const assemblyFields = {
            tenantId: _.get(this.props, 'user.tenantId', ''),
            userId: _.get(this.props, 'cognitoUser.username', _.get(this.props, 'cognitoUser.username', '')),
            userName: _.get(this.props, 'cognitoUser.attributes.name', ''),
            itemId: this.props.itemId,
            accessToken: tokens.accessToken.jwtToken,
            identityToken: tokens.idToken.jwtToken,
          };

          if (file.type.startsWith("image")) {
            templateId = process.env.REACT_APP_TEMPLATE_THUMBNAIL_UPLOAD; // {stage}_image_create_thumbnail
          }

          return {
            params: {
              auth: { key: process.env.REACT_APP_TRANSLOADIT_AUTH_KEY},
              template_id: templateId,
              notify_url: NOTIFY_URL
             },
            fields: assemblyFields
          }
        }
      }
    );

    uppy.on('file-removed', file => {
    });

    uppy.on('file-added', file => {
      if (file.name === 'noname') {
        uppy.removeFile(file.id);

        if (file.remote && file.remote.body.url) {
          let fileUrl = file.remote.body.url;
          const lastCharacter = fileUrl.charAt(fileUrl.length - 1);

          if (lastCharacter === '/') {
            fileUrl = fileUrl.slice(0, fileUrl.length - 1);
            uppy.getPlugin('Url').addFile(fileUrl);
          }
          uppy.setFileMeta(file.id, { name: fileUrl});
        }
      }
    });

    uppy.on('complete', result => {
      addEventNameToEndpoint(this.props.Analytics, `${_.get(this.props.cognitoUser, 'attributes[custom:role]', '')}-thumbnail-update`);
      
      this.props.Analytics.record({
        name: `${_.get(this.props.cognitoUser, 'attributes[custom:role]', '')}-thumbnail-update`,
        attributes: {
          userId: _.get(this.props.cognitoUser, 'username', ''),
          itemCount: result.successful.length.toString(),
          path: this.props.path || '/details'
        }
      });

      if (result.failed.length === 0) {
        toast.success('Uploaded - thumbnail is processing... ', {
          position: toast.POSITION.TOP_RIGHT
        });
        
        this.props.onClose();
      }
    });
  };

  render() {
    return (
      <div className="upload-modal-content position-relative">
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <button className="position-absolute close-button" onClick={this.props.onClose}>X</button>
        <div className="uppy-thumbnail-container"></div>
      </div>
    );
  }
}

export default ChangeThumbnailModalContent;
